import { ChangeDetectorRef, Component,Input, ViewChild } from '@angular/core';
import { Platform,IonicPage, NavController, ModalController, MenuController, Events, LoadingController, Select, ActionSheetController } from 'ionic-angular';


import { Http, Headers } from '@angular/http';
import 'rxjs/add/operator/map';
import { LoginProvider } from '../../providers/login/login';
import { Storage } from '@ionic/storage';
import { environment } from '../../environments/environment';
import { DashboardPage } from '../dashboard/dashboard';
import { OtpLoginPage } from '../otp-login/otp-login';
import { ToastProvider } from '../../providers/toast/toast';
import { MobileAppService } from '../../services/mobile-app';
import { ForgotPasswordPage } from '../forgot-password/forgot-password';
import { UtilService } from '../../services/util';
import { HowItWorksPage } from '../how-it-works/how-it-works';
import { TranslateService } from '@ngx-translate/core';
import { SignUpNumberPage } from '../sign-up-number/sign-up-number';
import { SettingsProvider  } from '../../providers/settings/settings';
// import { SignUpFormPage } from '../sign-up-form/sign-up-form';

@IonicPage()
@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
})
export class HomePage {
  data: any = {};
  events: any = {};
  aggree = true;
  @Input() multipleLoginUserId: any = null;

  loading = {
    login: false
  };
  languages  : any;
  keys = []
  lang : any;
   
  officeName : any;
   
  public multiple: any = null;

  public username: string;
  public password: string;
  tenant = false;
  selRegistrationLogin : any;

  private isUsernameValid: boolean = true;
  private isPasswordValid: boolean = true;

  private showDetails: boolean = false;
  public message = {
    text : "",
    color : ""
  };

  passwordType: string = 'password';
  passwordIcon: string = 'eye-off';

  private users = []
  constructor(public platform: Platform,public navCtrl: NavController,
    public modalCtrl: ModalController, 
     private translate: TranslateService,
    public http:Http,
    private loginProvider: LoginProvider,
    private storage: Storage,
    private menu: MenuController,
    public event: Events,
    private loadingCtrl: LoadingController,
    private toast: ToastProvider,
    private appService: MobileAppService,
    private settingsProvider : SettingsProvider,
    // private mobileApp: MobileAppService,
    private util: UtilService,
    private ref: ChangeDetectorRef,
    public actionSheetController: ActionSheetController) {
      setInterval(() => {
        try{
          this.ref.detectChanges();
        }catch(e){}
      }, 500);

      this.selRegistrationLogin = localStorage.getItem('signup_login')
      this.languages = environment.languages;
      this.keys = Object.keys(this.languages);
      this.lang = this.translate.currentLang;

      platform.ready().then(() => { 
      var skipTutorial = localStorage.getItem('skip_tutorial')
      environment.debug && console.log(skipTutorial)
      if(skipTutorial != 'true'){
        this.openHowItWorks()
      }
    });

      this.officeName = environment.officeName
      environment.debug && console.log(this.officeName);
      var lang = localStorage.getItem('lang');
      environment.debug && console.log(lang, "lang in home.ts ")
      if(!lang){
        lang = translate.getBrowserLang();
        environment.debug && console.log(lang, "browser lang in home.ts")
      }     
      this.translate.use(lang.match(/en|zh|vi|km|/) ? lang : 'en');
      localStorage.setItem('lang', lang); 
      if(environment.debug) console.log("Selected language => ", 'en'); 
      this.menu.enable(true);
      this.data = {
      "background"      : "assets/images/background/26.jpg",
      "username"        : "Username",
      "password"        : "Password",
      "labelUsername"   : "USERNAME",
      "labelPassword"   : "PASSWORD",
      "register"        : "Register now!",
      "forgotPassword"  : "Forgot password?",
      "login"           : "Login",
      "loginFacebook"   : "Login With",
      "subtitle"        : "Welcome to iSocietyManager",
      "title"           : "Login to your account",
      "otp"             : "OTP Login",
      "logo"            : "assets/images/logo/Final_logo"+(environment.icon?environment.icon:'')+".png",      
      "errorUser"       : "Field can't be empty",
      "errorPassword"   : "Field can't be empty"
    };

    
    if(this.selRegistrationLogin){
     
      this.navCtrl.setRoot(DashboardPage);
      
      environment.debug && console.log(this.menu)
    }else{
    this.events = {};
    setTimeout(() => {
      this.storage.get("loginDetails").then((loginDetails) => {
          if(loginDetails ){
            if(environment.debug) console.log("login detail found after 500 ms =>", new Date());
            this.checkLogin()
          }else{
            if(environment.debug) console.log("login detail not found after 500 ms => =>", loginDetails, new Date());
            this.checkLogin();
            setTimeout(() => {
            this.storage.get("loginDetails").then((loginDetails) => {
              if(loginDetails){
                if(environment.debug) console.log("login detail found after 500 ms =>", new Date());
                this.checkLogin()
              }
            });
          }, 2000);
        }
      });
       
    }, 500);
    // setTimeout(()=>{
    //   console.log('changing theme:....')
    //   this.changeColor('red')
    // },5000)
  }
    
  }
//   changeColor(color:string){
//     var r = document.querySelector(':root');
//     var rs = getComputedStyle(r);
//     console.log(rs)
//     let root = document.documentElement;

//     console.log(root.style.getPropertyValue('accentColor'));
//     root.style.setProperty('accentColor', "red");
//     console.log(root.style.getPropertyValue('accentColor'));

//     // document.documentElement.style.setProperty('--theme-accent', color);
//  }
 
  selectLogin(userData){
    if(environment.debug) console.log("Enter selectLogin() =>", userData, new Date());
    this.loginProvider.logOut();
    this.users = [];
    setTimeout(() => {
      if(environment.debug) console.log("selectLogin() after time out =>", new Date());
      if(userData){
        this.storage.set("loginDetails", userData).then(val => {
          if(environment.debug) console.log("selectLogin()=>this.storage.set(loginDetails) result =>", val, new Date());
          if(environment.runAs == environment.constant.APP) this.appService.registerApp();
          this.loginProvider.setSocietySettings(userData);
          this.event.publish('user:created', userData);
          
          (environment.switchToWeb) ? this.appService.switchToWeb() : this.navCtrl.setRoot(DashboardPage);
        
        });
      }
      // this.continueLogin();
    },1000);
  }
  checkLogin(){
    try{
      this.appService.getIntent(d=>{
        if(d && d.extras && ('token' in d.extras && 'site' in d.extras) && (d.extras.token != "" && d.extras.site != "") && MobileAppService.islogout == 0 ){
          this.loginProvider.logintokenuser(d.extras.site, d.extras.token).then(res=>{
            let intentUserData = res.data;
            if(res.status == 'success'){
              this.storage.get("loginDetails").then((loginDetails) => {
                if(loginDetails){
                  if(loginDetails.id == intentUserData.id){
                    this.continueLogin();
                  }else{
                    this.users = [];
                    this.users.push(loginDetails)
                    this.users.push(intentUserData)
                  }
                }else{
                    this.selectLogin(intentUserData)
                }
              }).catch(e => {
                console.log("Error in storage.get(loginDetails) =>", e);
                this.continueLogin();
              });
            }else{
              this.toast.presentToast(res.message, 1, 5000);
              this.continueLogin();
            }
          })
        }else{
          this.continueLogin();
        }
      }, e=>{
        console.error("Error in getIntent() =>", e);
        this.continueLogin()
      });
    }catch(e){
      console.error("Error in checkLogin()", e);
      this.continueLogin()
    }
  }
  continueLogin(){
    if(environment.debug) console.log("Enter continueLogin() =>",new Date());
    MobileAppService.islogout = 0
    this.loginProvider.isLogin().then((val) => {  
      if(environment.debug) console.log("continueLogin()=>isLogin() value =>", val, new Date());    
      if(val){
        if(environment.debug) console.log("continueLogin()=>isLogin() value found =>", val, new Date());
        this.storage.get("loginDetails").then((val) => {
          if(environment.debug) console.log("storage.get(loginDetails) value =>", val, new Date());
          // this.event.publish('user:created', val);
          this.storage.get("loginDetails").then((val) => {
            if(val){
              this.loginProvider.updateUserRegisterApp(val);
              this.toast.presentToast('Welcome back', 2);
            } 
          })
        });
        if(environment.debug) console.log("continueLogin() before switchToWeb() =>", new Date());
        
        (environment.switchToWeb) ? this.appService.switchToWeb() : this.navCtrl.setRoot(DashboardPage);}
      else{
        if(environment.appName == "ism_web"){
          window.location.href = environment.baseUrl;
        }else{
          this.toast.presentToast("Please login first");
          this.showDetails = true;
        }
      }
    })
  }
  async selectFromMultipleLogin() {
    if(this.multiple){
      var buttons = [];
      this.multiple.forEach(user => {
        buttons.push({
          text: user.society_name +' '+( (user.flat_no)?user.flat_no:user.name) ,
          icon: 'ios-arrow-forward-outline',
          handler: () => {
            environment.debug && console.log(user);
            this.multipleLoginUserId = user.user_id;
            this.onEvent('onLogin');
          }
        })
      });
    const actionSheet = await this.actionSheetController.create({
      title: "Select a Login to continue...",
      cssClass:'my-custom-class',
      buttons: [...buttons,
        {
          text: 'Cancel',
          // icon: 'close',
          role: 'cancel',
          handler: () => {
            environment.debug && console.log('Cancel clicked');
          }
        }
      ]
    });
    await actionSheet.present();
  }
  }

  onEvent = (event: string): void => {
    if (event == "onLogin" && !this.validate()) {
      return ;
    }
    this.loading.login = true;
    this.showDetails = true;
    var params = {
      'identity' : this.username,
      'password' : this.password,
      'user_id' : this.multipleLoginUserId,
      'tenant' : this.tenant?1:0,
    }
    this.loginProvider.login(params).subscribe((res) => {
      this.loading.login = false;
      if(res.status == 'multipleLogin'){
        this.message = {text: res.message, color: "green"};
        this.multiple = res.data;
        setTimeout(() => {
          this.selectFromMultipleLogin()
        },150);
      }else if(res.status == 'success' && res.data){
        if(environment.debug) console.log("Login success result =>", res.data);
        if(environment.allowRole.indexOf(res.data.role) != -1){
          if(environment.debug) console.log("Login role =>", res.data.role, new Date());
          this.storage.set('loginDetails', res.data).then(val=>{
            if(environment.debug) console.log("storage.get(loginDetails) =>", this.storage.get('loginDetails'));
            this.loginProvider.updateUserRegisterApp(res.data);
            this.event.publish('user:created', res.data);
            if(environment.debug) console.log("Login before switchToWeb() in onEvent() =>", new Date());
           
            (environment.switchToWeb) ? this.appService.switchToWeb() : this.navCtrl.setRoot(DashboardPage);
          
          })
         
        }else {
          this.message = {text: `This App is not for ${res.data.role}`, color: 'red'};
          this.multiple = null;
          this.multipleLoginUserId = null;
        }
      }else{
        this.message = {text: res.message, color: 'red'};
        this.password = "";
        this.multiple = null;
        this.multipleLoginUserId = null;
      }
    }, err => {
      console.error("Error in login =>", err, new Date());
      this.loading.login = false;
      this.util.showNoInternet();
    });
  }

  onMultipleSelect($event){
    this.multipleLoginUserId = $event;
    this.onEvent('onLogin');
  }

  openBaseSpecificUri(url:string){
    this.util.openWithInAppBrowser(environment.baseUrl + url);
  }

  onOtpLogin() {
    this.navCtrl.push(OtpLoginPage);
  }

  onForgotPass(){
    this.navCtrl.push(ForgotPasswordPage);
  }

  validate():boolean {
    this.isUsernameValid = true;
    this.isPasswordValid = true;

    if (!this.username ||this.username.length == 0) {
        this.isUsernameValid = false;
    }

    if (!this.password || this.password.length == 0) {
        this.isPasswordValid = false;
    }

    if(!this.aggree){
      this.toast.presentToast("You must agree the terms to continue...");
      return false;
    }

    return this.isPasswordValid && this.isUsernameValid;
  }

  presentProfileModal() {
    const profileModal = this.modalCtrl.create("IntroPage");
    profileModal.present();
  }

  goSignUp(){
    this.navCtrl.push(SignUpNumberPage, {


    });
  }

  openHowItWorks(){
    this.navCtrl.push(HowItWorksPage, {
      title: "App tour",
      last_page_title : "Ready to log-in"
    });
  }

  hideShowPassword() {
    this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
    this.passwordIcon = this.passwordIcon === 'eye-off' ? 'eye' : 'eye-off';
}

   trim(username){
     this.username = username.trim()
     return this.username
   }


}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts